"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Exception_1 = require("../../Exceptions/Exception");
var SqlParser_1 = require("../../Parsers/SQL/SqlParser");
var ConnectionStringUtils_1 = require("../../Utils/ConnectionStringUtils");
var NumberUtils_1 = require("../../Utils/NumberUtils");
var SqlType_1 = require("../../Utils/SqlType");
var StringBuilder_1 = require("../../Utils/StringBuilder");
var StringUtils_1 = require("../../Utils/StringUtils");
var TextUtils_1 = require("../../Utils/TextUtils");
var Utils_1 = require("../../Utils/Utils");
var XoneJSONResulset_1 = require("./XoneJSONResulset");
var XoneJSONConnection = /** @class */ (function () {
    /**
     *
     */
    function XoneJSONConnection(sConnectionString, sAppName, sExecutionPath, cryptoData) {
        // Cliente para conectar con LogonTest
        // private m_clientId = "XIdsAPIdUQMB9bzf5";
        // private m_clientSecret = "q5d007Ma19GM1jN0IMhl6uqjKt7PoO";
        // Cliente para conectar con AllByxone
        this.m_clientId = "XIdsAPIXmITgixqqj";
        this.m_clientSecret = "5M3c9Oae5A7ewzTDU2Z3xh1B9P0Z79";
        // Prod
        this.m_url = "https://web.xonedev.cloud/api/itf/DoAction";
        // local
        //private m_url = "http://localhost:1854/api/itf/DoAction";
        this.m_idsUrl = "https://ids.xonedev.cloud/connect/token";
        this.nFlags = 1;
        this.nTimeout = 60;
        this.nSecurityLevel = 0;
        this.sAppName = sAppName;
        this.sExecutionPath = sExecutionPath;
        this.bIsLoginCall = false;
        this.cryptoData = cryptoData;
        this.m_token = null;
        this.parseConnectionString(sConnectionString);
    }
    XoneJSONConnection.prototype.executeUpdateAsync = function (Sentence) {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.executeNonQuery = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var token, response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readBearerTokenAsync()];
                    case 1:
                        token = _a.sent();
                        if (TextUtils_1.default.isEmpty(token))
                            throw new Exception_1.Exception("No Auth");
                        return [4 /*yield*/, fetch(this.m_url, {
                                method: "POST",
                                //mode: 'no-cors', // no-cors, *cors, same-origin
                                // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                                //credentials: 'omit', // include, *same-origin, omit
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "Bearer " + token,
                                },
                                //redirect: 'follow', // manual, *follow, error
                                // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                                body: JSON.stringify(data),
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        result = _a.sent();
                        return [2 /*return*/, 1];
                }
            });
        });
    };
    XoneJSONConnection.prototype.getDataFromParser = function (parser) {
        return parser.GetFields().toJSON();
        // const data = [];
        // data.push(parser.GetFields().toJSON());
        // return data;
    };
    XoneJSONConnection.prototype.formatOnlineData = function (parser, collName, keys) {
        if (parser.GetSqlType() == SqlType_1.default.SQLTYPE_SELECT) {
            return {
                coll: collName,
                action: "select",
                where: parser.GetWhereSentence(),
            };
        }
        if (parser.GetSqlType() == SqlType_1.default.SQLTYPE_UPDATE || parser.GetSqlType() == SqlType_1.default.SQLTYPE_INSERT) {
            return {
                coll: collName,
                action: "write",
                data: this.getDataFromParser(parser),
                keys: parser.getKeys(),
                where: parser.GetWhereSentence(),
            };
        }
        if (parser.GetSqlType() == SqlType_1.default.SQLTYPE_DELETE) {
            return {
                coll: collName,
                action: "drop",
                data: this.getDataFromParser(parser),
                keys: parser.getKeys(),
                where: null,
            };
        }
        return {};
        // if (parser.GetSqlType() == SqlType.SQLTYPE_INSERT) {
        //     return {
        //         coll: collName,
        //         action: "write",
        //         data: this.getDataFromParser(parser),
        //         keys: parser.getKeys(),
        //         data: this.getDataFromParser(parser)
        //     };
        // }
    };
    XoneJSONConnection.prototype.executeAsync = function (Sentence, MaxRows) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof Sentence == "string") {
                            tmp = new SqlParser_1.SqlParser("ROWID");
                            tmp.ParseSqlString(Sentence);
                            Sentence = tmp;
                        }
                        return [4 /*yield*/, this.executeNonQuery(this.formatOnlineData(Sentence, args[0], args[1]))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    XoneJSONConnection.prototype.getAuthData = function () {
        var bld = new StringBuilder_1.default("client_id=");
        bld.append(this.m_clientId);
        bld.append("&client_secret=");
        bld.append(this.m_clientSecret);
        bld.append("&grant_type=client_credentials");
        return bld.toString();
    };
    XoneJSONConnection.prototype.readBearerTokenAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, token, expire;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.m_token != null) {
                            if (this.m_token.expires_in > new Date())
                                return [2 /*return*/, this.m_token.access_token];
                        }
                        return [4 /*yield*/, fetch(this.m_idsUrl, {
                                method: "POST",
                                //mode: "no-cors",
                                // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                                // credentials: 'same-origin', // include, *same-origin, omit
                                headers: {
                                    //'Content-Type': 'application/json',
                                    "Content-Type": "application/x-www-form-urlencoded",
                                },
                                //redirect: 'follow', // manual, *follow, error
                                //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                                body: this.getAuthData(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        token = _a.sent();
                        if (token.error) {
                            console.error(token.error);
                            return [2 /*return*/, (this.m_token = null)];
                        }
                        expire = new Date();
                        expire.setSeconds(expire.getSeconds() + token.expires_in);
                        this.m_token = token;
                        this.m_token.expires_in = expire;
                        return [2 /*return*/, token.access_token];
                }
            });
        });
    };
    XoneJSONConnection.prototype.executeQuery = function (Sentence) {
        return new XoneJSONResulset_1.default();
    };
    XoneJSONConnection.prototype.fetchDataAsync = function (Sentence, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.sUrlAddress, {
                            method: this.sMethod,
                            //mode: 'no-cors', // no-cors, *cors, same-origin
                            // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                            //credentials: 'omit', // include, *same-origin, omit
                            headers: {
                                "Content-Type": "application/json",
                            },
                            //redirect: 'follow', // manual, *follow, error
                            // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                            body: JSON.stringify(data),
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    XoneJSONConnection.prototype.executeQueryAsync = function (Sentence) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var parser, data, rs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parser = new SqlParser_1.SqlParser("ROWID");
                        parser.ParseSqlString(Sentence);
                        data = {
                            action: "select",
                            where: parser.GetWhereSentence(),
                            sort: parser.getOrderBySentence(),
                        };
                        data = __assign(__assign({}, data), args[0]);
                        rs = new XoneJSONResulset_1.default(this, Sentence, data);
                        return [4 /*yield*/, rs.populate()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    XoneJSONConnection.prototype.prepareNormalData = function (body) { };
    // async executeQueryAsyncOld(Sentence: any, ...args): Promise<IResultSet> {
    //     var token = await this.readBearerTokenAsync();
    //     if (TextUtils.isEmpty(token))
    //         throw new Exception("No Auth");
    //     var parser = new SqlParser("ROWID");
    //     parser.ParseSqlString(Sentence as string);
    //     var data = {
    //         //count:args.length>0?args[0]:false,
    //         //coll: args.length>1?args[1]:"",
    //         action: "select",
    //         where: parser.GetWhereSentence(),
    //         sort: parser.getOrderBySentence()
    //         //page: args.length>2?args[2]:{}
    //     };
    //     this.m_data = { ...data, ...args[0] };
    //     const response = await fetch(this.m_url, {
    //         method: 'POST', // *GET, POST, PUT, DELETE, etc.
    //         //mode: 'no-cors', // no-cors, *cors, same-origin
    //         // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    //         //credentials: 'omit', // include, *same-origin, omit
    //         headers: {
    //             'Content-Type': 'application/json',
    //             "Authorization": "Bearer " + token
    //             // 'Content-Type': 'application/x-www-form-urlencoded',
    //         },
    //         //redirect: 'follow', // manual, *follow, error
    //         // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    //         body: JSON.stringify(this.m_data) // body data type must match "Content-Type" header
    //     });
    //     const result = await response.json();
    //     return this.m_resulset = new XoneJSONResulset(result.data);
    //     // return this.readBearerTokenAsync().then((token) => {
    //     //     if (TextUtils.isEmpty(token))
    //     //         throw new Exception("No Auth");
    //     //     var parser=new SqlParser("ROWID");
    //     //     parser.ParseSqlString(Sentence as string);
    //     //     var data= {
    //     //         coll: args[0],
    //     //         action: "select",
    //     //         where: parser.GetWhereSentence()
    //     //     };
    //     //     const response = fetch(this.m_url, {
    //     //         method: 'POST', // *GET, POST, PUT, DELETE, etc.
    //     //         mode: 'no-cors', // no-cors, *cors, same-origin
    //     //         // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    //     //         //credentials: 'omit', // include, *same-origin, omit
    //     //         headers: {
    //     //         'Content-Type': 'application/json',
    //     //         "Authorization": "Bearer "+token
    //     //         // 'Content-Type': 'application/x-www-form-urlencoded',
    //     //         },
    //     //         //redirect: 'follow', // manual, *follow, error
    //     //         // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    //     //         body: JSON.stringify(data) // body data type must match "Content-Type" header
    //     //     });
    //     //     return response.then((value)=>
    //     //             value.json().then((result)=>
    //     //                 new XoneJSONResulset(result.data)))
    //     //             .catch((reason)=> {
    //     //                 console.error(reason);
    //     //                 return null;
    //     //             });
    //     // });
    // }
    XoneJSONConnection.prototype.countAsync = function (Sentence) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var parser, data, rs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parser = new SqlParser_1.SqlParser("ROWID");
                        parser.ParseSqlString(Sentence);
                        data = {
                            action: "count",
                            where: parser.GetWhereSentence(),
                            sort: parser.getOrderBySentence(),
                        };
                        data = __assign(__assign({}, data), args[0]);
                        rs = new XoneJSONResulset_1.default(this, Sentence, data);
                        return [4 /*yield*/, rs.populate()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    XoneJSONConnection.prototype.parseConnectionString = function (sConnection) {
        var parameters = ConnectionStringUtils_1.default.parseConnectionString(sConnection);
        this.bIsLoginCall = StringUtils_1.default.ParseBoolValue(parameters.get("logincall"));
        // TAG 20050201: Luis: Permitir una primera aproximacion a authorization por JWT
        // En el connstring debe ponerse jwtcall=true y el token que se tenga
        this.bIsJWTCall = StringUtils_1.default.ParseBoolValue(parameters.get("jwtcall"));
        this.sToken = StringUtils_1.default.SafeToString(parameters.get("token"), Utils_1.Utils.EMPTY_STRING);
        this.nFlags =
            this.nFlags |
                (StringUtils_1.default.ParseBoolValue(parameters.get("odataformat")) ? XoneJSONConnection.FLAG_XONEJSONODATA : XoneJSONConnection.FLAG_XONEJSONSQL);
        this.nFlags =
            this.nFlags |
                (StringUtils_1.default.ParseBoolValue(parameters.get("customformat")) ? XoneJSONConnection.FLAG_XONEJSONCUSTOM : XoneJSONConnection.FLAG_XONEJSONSQL);
        this.nTimeout = NumberUtils_1.default.SafeToInt(parameters.get("timeout"), 60);
        this.nSecurityLevel = NumberUtils_1.default.SafeToInt(parameters.get("security level"), 0);
        this.sUrlAddress = parameters.get("data source");
        if (this.sUrlAddress != null) {
            this.sUrlAddress = this.sUrlAddress.trim();
            if (this.sUrlAddress.endsWith("?")) {
                this.sUrlAddress = this.sUrlAddress.substring(0, this.sUrlAddress.length - 1);
            }
        }
        else {
            this.sUrlAddress = Utils_1.Utils.EMPTY_STRING;
        }
        this.sMethod = parameters.get("method");
        if (this.sMethod == null) {
            this.sMethod = "POST";
        }
        this.sUsername = parameters.get("xoneuser");
        if (this.sUsername == null) {
            this.sUsername = Utils_1.Utils.EMPTY_STRING;
        }
        this.sPassword = parameters.get("xonepass");
        if (this.sPassword == null) {
            this.sPassword = Utils_1.Utils.EMPTY_STRING;
        }
        this.sEndpoint = parameters.get("endpoint");
        if (this.sEndpoint == null) {
            this.sEndpoint = Utils_1.Utils.EMPTY_STRING;
        }
        // TAG 20050208: Luis: Permitir customizar mas las colecciones online
        // en el connstring se puede poner Action=nombreaccion y AuthAction=nombreaccionauth
        this.sAction = StringUtils_1.default.SafeToString(parameters.get("action"), XoneJSONConnection.DEFAULT_ACTION_NAME);
        this.sAuthAction = StringUtils_1.default.SafeToString(parameters.get("authaction"), XoneJSONConnection.DEFAULT_AUTHACTION_NAME);
        this.sContentType = StringUtils_1.default.SafeToString(parameters.get("content-type"), XoneJSONConnection.DEFAULT_CONTENT_TYPE);
        this.bIsSqlQuery = StringUtils_1.default.ParseBoolValue(parameters.get("sqlquery"), true);
        // TAG: 0604201601 nuevo parametro en el connstring para poder codeficar el cupero del post en formato key=valeu&key=vale
        this.bPostUrlEncode = StringUtils_1.default.ParseBoolValue(parameters.get("postencode"), false);
        this.bIsCertificatePinningEnabled = StringUtils_1.default.ParseBoolValue(parameters.get("enablecertificatepinning"));
        this.sLocalCertPath = StringUtils_1.default.SafeToString(parameters.get("localcertificatepath"));
        // Para la autenticacion remota, puede ser por conexion o por llamada del script del metodo
        this.bAuthenticate = StringUtils_1.default.ParseBoolValue(parameters.get("auth"), false);
        if (this.bAuthenticate) {
            this.sAuthenticationUsername = parameters.get("user id");
            this.sAuthenticationPassword = parameters.get("password");
        }
        this.bUseRemoteBroker = StringUtils_1.default.ParseBoolValue(parameters.get("remote broker"), false);
        this.sRemoteMapped = StringUtils_1.default.SafeToString(parameters.get("remote mapped"));
        this.sRemoteDest = StringUtils_1.default.SafeToString(parameters.get("remote destination"));
        this.bAllowUnsafeCertificates = StringUtils_1.default.ParseBoolValue(parameters.get("allowunsafecertificates"), false);
    };
    XoneJSONConnection.prototype.createStatement = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.isClosed = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.commit = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.beginTrans = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.rollback = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.execute = function (parameter, MaxRows) {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.executeUpdate = function (Sentence) {
        return 0;
    };
    XoneJSONConnection.prototype.executeOperation = function (OperType, tableName, values, whereClause) {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.getDBMS = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.outerJoinsSupported = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.acceptsParsedSentences = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.acceptsEmptyQueries = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.LastRowsAffected = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.LastInsertedRowId = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.cancelProcesses = function (flags) {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.setCryptoData = function (cryptoData) {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.getCryptoData = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.cryptoSupported = function () {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.getTokenFromAuth = function (login, pass) {
        throw new Error("Method not implemented.");
    };
    XoneJSONConnection.prototype.getFlags = function () {
        return this.nFlags;
    };
    XoneJSONConnection.prototype.isSqlQueryDisabled = function () {
        return !this.bIsSqlQuery;
    };
    XoneJSONConnection.prototype.getMethod = function () {
        return this.sMethod;
    };
    /**
     * name
     */
    XoneJSONConnection.prototype.name = function () { };
    XoneJSONConnection.prototype.getUrlAddress = function () {
        return this.sUrlAddress;
    };
    XoneJSONConnection.DEFAULT_CONTENT_TYPE = "application/x-www-form-urlencoded";
    // TAG 20050208: Luis: Permitir customizar mas las colecciones online
    XoneJSONConnection.DEFAULT_ACTION_NAME = "Action";
    XoneJSONConnection.DEFAULT_AUTHACTION_NAME = "Auth";
    XoneJSONConnection.FLAG_XONEJSONSQL = 1;
    XoneJSONConnection.FLAG_XONEJSONODATA = 2;
    XoneJSONConnection.FLAG_XONEJSONCUSTOM = 4;
    return XoneJSONConnection;
}());
exports.default = XoneJSONConnection;

//# sourceMappingURL=XoneJSONConnection.js.map
